module.exports = __webpack_public_path__ + "img/lb_check.637876c7.svg";